export default __webpack_public_path__ + "static/media/youtube-rewind.c724ed2e.mp4";